"use strict";

(function () {
  const dialog = document.getElementById("modalCompareTable");
  if (!dialog) return;

  const scrollEl = dialog.querySelector(".p-modalCompareTable__scroll");
  const stage = dialog.querySelector(".p-modalCompareTable__stage");
  const img = stage ? stage.querySelector("img") : null;
  const mq = window.matchMedia("(max-width: 767px)");

  if (!scrollEl || !stage || !img) return;

  const MIN_SCALE = 1;
  const MAX_SCALE = 4;

  let scale = 1;
  let translateX = 0;
  let translateY = 0;
  let startDistance = 0;
  let startScale = 1;
  let isPanning = false;
  let isPinching = false;
  let lastPanX = 0;
  let lastPanY = 0;

  function getTouchDistance(touches) {
    const dx = touches[1].clientX - touches[0].clientX;
    const dy = touches[1].clientY - touches[0].clientY;
    return Math.hypot(dx, dy);
  }

  function setZooming(active) {
    scrollEl.classList.toggle("is-zooming", active);
  }

  function clampToViewport() {
    const viewport = scrollEl.getBoundingClientRect();
    const content = stage.getBoundingClientRect();
    let deltaX = 0;
    let deltaY = 0;

    if (content.width <= viewport.width) {
      deltaX = viewport.left + viewport.width / 2 - (content.left + content.width / 2);
    } else if (content.left > viewport.left) {
      deltaX = viewport.left - content.left;
    } else if (content.right < viewport.right) {
      deltaX = viewport.right - content.right;
    }

    if (content.height <= viewport.height) {
      deltaY = viewport.top + viewport.height / 2 - (content.top + content.height / 2);
    } else if (content.top > viewport.top) {
      deltaY = viewport.top - content.top;
    } else if (content.bottom < viewport.bottom) {
      deltaY = viewport.bottom - content.bottom;
    }

    if (deltaX !== 0 || deltaY !== 0) {
      translateX += deltaX;
      translateY += deltaY;
      stage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    }
  }

  function applyTransform() {
    if (scale <= MIN_SCALE) {
      translateX = 0;
      translateY = 0;
      stage.style.transform = "";
      setZooming(false);
      return;
    }

    setZooming(true);
    stage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    clampToViewport();
  }

  function resetZoom() {
    scale = 1;
    translateX = 0;
    translateY = 0;
    isPanning = false;
    isPinching = false;
    stage.style.transform = "";
    setZooming(false);
  }

  function resetAll() {
    resetZoom();
    scrollEl.scrollTop = 0;
    scrollEl.scrollLeft = 0;
  }

  scrollEl.addEventListener(
    "touchstart",
    (event) => {
      if (!mq.matches) return;

      if (event.touches.length === 2) {
        isPinching = true;
        isPanning = false;
        startDistance = getTouchDistance(event.touches);
        startScale = scale;
        setZooming(true);
        return;
      }

      if (event.touches.length === 1 && scale > MIN_SCALE) {
        isPanning = true;
        lastPanX = event.touches[0].clientX;
        lastPanY = event.touches[0].clientY;
        setZooming(true);
      }
    },
    { passive: true }
  );

  scrollEl.addEventListener(
    "touchmove",
    (event) => {
      if (!mq.matches) return;

      if (event.touches.length === 2 && isPinching) {
        event.preventDefault();
        const distance = getTouchDistance(event.touches);
        scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, startScale * (distance / startDistance)));
        applyTransform();
        return;
      }

      if (isPanning && event.touches.length === 1 && scale > MIN_SCALE) {
        event.preventDefault();
        const touch = event.touches[0];
        translateX += touch.clientX - lastPanX;
        translateY += touch.clientY - lastPanY;
        lastPanX = touch.clientX;
        lastPanY = touch.clientY;
        applyTransform();
      }
    },
    { passive: false }
  );

  function onTouchEnd(event) {
    if (event.touches.length > 0) return;

    isPinching = false;
    isPanning = false;

    if (scale <= MIN_SCALE) {
      resetZoom();
      return;
    }

    applyTransform();
  }

  scrollEl.addEventListener("touchend", onTouchEnd);
  scrollEl.addEventListener("touchcancel", onTouchEnd);

  dialog.addEventListener("close", resetAll);

  document.querySelectorAll('[data-dialog="modalCompareTable"]').forEach((button) => {
    button.addEventListener("click", () => {
      if (!mq.matches) return;
      resetAll();
    });
  });
})();
